import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Actions from '../../actions/actions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Autocomplete from '@mui/material/Autocomplete';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/IconButton';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { weight_verified_scale_values } from '../utils.js';
import {Checkbox, Grid} from "@mui/material";
import moment from "moment";
import {Constants} from "../DashBoard/Constants";
import {all, put} from "redux-saga/effects";
import {LOAD_SKUSBY_REFRENCE_WITH_ERROR} from "../../actions/actions";


let LBL_SEARCH_SKU = "Search SKU"
let LBL_REFERENCE = "reference";
let LBL_UPC = "upc"
let checkOption = LBL_SEARCH_SKU;
let customerName = "";
let customerId = "";

let dcName = "";
let dcId = "";
let customerDCs = []

let upcNumber = "";
let vorRefNumber = "";
let skuDescption = "";
let skuDescriptionId = "";
let customerReferenceId = "";
let submitButtonFlag = false;
let ignoreStatus = false;
let dataLoading = false;
let searchClick = false;
let isBrandsLoaded = false;
let isSkuDescLoaded = false;
let isLoaded = false;
let isCustomerSubmitted = false;
let isDCSubmitted = false;
const SkuUpdateTabAttribute = ({user, ...props}) => {
    const [brands, setBrands] = useState(props.brands);
    const [selectedBrand, setSelectedBrand] = useState('');
    const [selectedBrandId, setSelectedBrandId] = useState('');
    const [packageType, setPackageType] = useState(props.packageType);
    const [allskus, setAllskus] = useState(props.skusbydesc);
    const [selectedPackageType, setSelectedPackageType] = useState('');
    const [selectedPackageTypeId, setSelectedPackageTypeId] = useState();
    const [referenceNumber, setReferenceNumber] = useState(vorRefNumber);
    const [searchSKU, setSearchSKU] = useState(skuDescption);
    const [selectedrefrence, setSelectedrefrence] = useState(skuDescriptionId);
    const [custReferenceId, setCustReferenceId] = useState(customerReferenceId);
    const [upc, setUpc] = useState(upcNumber);
    const [formUPC, setFormUPC] = useState(undefined);
    const [caseUPC, setCaseUPC] = useState(undefined);
    const [unitUPC, setUnitUPC] = useState(undefined);
    const [weightVerifiedValues, setWeightVerifiedValues] = useState(weight_verified_scale_values);

    const [weight, setWeight] = useState();
    const [height, setHeight] = useState();
    const [length, setLength] = useState();
    const [width, setWidth] = useState();
    const [skuPackagesPerCase, setSkuPackagesPerCase] = useState();

    const [skuVORRefNumber, setSKUVORRefNumber] = useState();
    const [skuCustRefNumber, setSKURefNumber] = useState();
    const [skuDescription, setSKUDescription] = useState();

    const [dcweight, setDCWeight] = useState();
    const [dcheight, setDCHeight] = useState();
    const [dclength, setDCLength] = useState();
    const [dcwidth, setDCWidth] = useState();
    const [dcskuPackagesPerCase, setDCSkuPackagesPerCase] = useState();

    const [ignoreSKU,setIgnoreSKU] = useState(ignoreStatus);
    const [ignoreSKULUD,setIgnoreSKULPD] = useState("")
    const [unitsPerCase, setUnitsPerCase] = useState();
    const [skuAttributeType, setSkuAttributeType] = useState(checkOption);
    const [customersVorList, setCustomersVorList] = useState(props.customersVorList);
    const [skubyref, setSkubyref] = useState(props.skubyrefrence);

    const [selectedCustomer, setSelectedCustomer] = useState(customerName);
    const [customerDC, setCustomerDC] = useState(customerDCs);
    const [selectedDC, setSelectedDC] = useState(dcName);
    const [selectedDCId, setSelectedDCId] = useState(dcId);
    const [selectedCustomerName, setSelectedCustomerName] = useState('');
    const [selectedCustomerId, setSelectedCustomerId] = useState(customerId);
    const [weightVerified, setWeightVerified] = useState();
    const [selectedWeightVerified, setSelectedWeightVerified] = useState('');
    const [dateweightverifiedCopy, setDateweightverifiedCopy] = useState('');
    const [dateWeightVerified, setDateWeightVerified] = useState(dayjs());
    const [indicatorOn, setIndicatorOn] = useState(false);
    const [listOpen, setListOpen] = useState(false);
    const [disable, setDisable] = useState(true);
    const [dcdisable, setDCDisable] = useState(true);
    const [success, setSuccess] = useState(props.updateweightstatus);
    const [error, setError] = useState(props.error);
    const [rand, setrand] = useState(Math.floor(Math.random()*10000));


    let enable = false;
    let error1 = false;

    useEffect(() => {
       // isDCSubmitted = false
        console.log(skubyref,user.canWrite);
       // clearAllVal();
        if(!searchClick){
           // clearFormData();
        }
        console.log("constants:"+Constants.DATA_LOADED)
        if(!Constants.DATA_LOADED){
            //props.skubyrefrence  = {}
            setSkuAttributeType(LBL_SEARCH_SKU);
            checkOption = LBL_SEARCH_SKU;
            setSelectedCustomer("");
            setSelectedCustomerId("")
            Constants.DATA_LOADED = true;
            setSelectedBrandId();
            setSelectedBrand()
            setSelectedPackageTypeId();
            setSelectedPackageType();

            setWeight();
            setLength();
            setHeight();
            setWidth();
            setSkuPackagesPerCase();
            setSKUVORRefNumber();
            setSKURefNumber();
            setSKUDescription();

            setDCWeight();
            setDCLength();
            setDCHeight();
            setDCWidth();
            setDCSkuPackagesPerCase();

            setUnitsPerCase();
            setWeightVerified();
            setDateWeightVerified();
            setReferenceNumber("");
            setUpc("");
            setFormUPC(undefined)
            setSearchSKU("")
            clearFormFields();
            setIgnoreSKU(false);
            // searchClick = false;
            setDisable(true);
            setDCDisable(true);
            isDCSubmitted = false;
            isCustomerSubmitted = false;
            setSearchSKU("")
            setSearchSKU("")
            setTimeout(()=>{
                setSelectedDC("")
                setCustomerDC([]);
                setFormUPC("")
                setSelectedCustomer("");
                setSelectedCustomerId("")
                skuDescriptionId = ""
                customerReferenceId = ""
                skuDescption = "";
                setSearchSKU("")
            },500)
            setSkubyref('');
            setListOpen(false);
            setSearchSKU();
            setDisable(true);
            setDCDisable(true);
            ignoreStatus = false;
            setIgnoreSKU(ignoreStatus);
            setIgnoreSKULPD("");
            upcNumber = "";
            vorRefNumber = "";
            skuDescriptionId = ""
            customerReferenceId = ""
            skuDescption = "";
            clearAllVal();

        }
        console.log("start screen")
        console.log(props.customersVorList);
        console.log(props.selectedDC);
        if(!submitButtonFlag){
            setCustomersVorList(props.customersVorList);
            props.onErrorUpdate();
            let jwt = localStorage.getItem('authToken');
            if(!isBrandsLoaded){
                props.fetchBrands(jwt, null);
                props.fetchPackageType(jwt, null);
                props.fetchSkusByDesc(jwt, null);
                isBrandsLoaded = true;
            }

        }

        return () => {
            dataLoading = false;
            if(!searchClick){
                //clearFormData();
            }
            //clearFormData();
        }

    }, []);

    useEffect(() => {
        setCustomersVorList(props.customersVorList);
    }, [props.customersVorList, selectedCustomer]);

    useEffect(() => {
        setTimeout(()=>{
            setIgnoreSKU(ignoreStatus);
        },1000);

        if(!submitButtonFlag) {
            setIgnoreSKU(ignoreStatus);
            setBrands(props.brands);
            setPackageType(props.packageType);
            setAllskus(props.skusbydesc);
            if (!selectedBrandId) {
                setSelectedBrandId();
            }
            if (!selectedPackageTypeId) {
                setSelectedPackageTypeId()
            }
        }

    }, [props.brands, props.packageType, props.skusbydesc, selectedBrandId, selectedPackageTypeId,]);

    useEffect(() => {
        setIgnoreSKU(ignoreStatus);
        if (!customersVorList || !props.skusbydesc) {
            setIndicatorOn(true);
        } else if (props.skubyrefrence) {
            setIndicatorOn(false);
        } else {
            setIndicatorOn(false);
        }
    }, [customersVorList, props.skusbydesc, props.skubyrefrence])

    useEffect(() => {
        if(searchClick){
            if (selectedrefrence && checkOption == LBL_SEARCH_SKU) {
                console.log(error);
                if(!isSkuDescLoaded){
                    if(submitButtonFlag && !error){
                        props.fetchSkuByRefrence(checkOption,selectedrefrence,'',selectedCustomerId,dcId);
                    }else if(!submitButtonFlag){
                        props.fetchSkuByRefrence(checkOption,selectedrefrence,'',selectedCustomerId,dcId);
                    }
                    isSkuDescLoaded = true;
                }

            }else if(checkOption == LBL_REFERENCE){
                if(submitButtonFlag && !error){
                    props.fetchSkuByRefrence(checkOption,vorRefNumber,upcNumber,selectedCustomerId,dcId);
                }else if(!submitButtonFlag){
                    props.fetchSkuByRefrence(checkOption,vorRefNumber,upcNumber,selectedCustomerId,dcId);
                }
            }else if(checkOption == LBL_UPC){
                if(submitButtonFlag && !error){
                    props.fetchSkuByRefrence(checkOption,vorRefNumber,upcNumber,selectedCustomerId,dcId);
                }else if(!submitButtonFlag){
                    props.fetchSkuByRefrence(checkOption,vorRefNumber,upcNumber,selectedCustomerId,dcId);
                }
            }
        }


    }, [selectedrefrence])

    useEffect(() => {
        try{

            if ((props.skubyrefrence) && ((checkOption == LBL_SEARCH_SKU) || (checkOption == LBL_REFERENCE && props.skubyrefrence.vor_reference_number == vorRefNumber) || (checkOption == LBL_UPC && props.skubyrefrence.upc == upcNumber))) {
                clearFormFields();
               // searchClick = false;
                setDisable(true);
                setDCDisable(true);
                isDCSubmitted = false;
                isCustomerSubmitted = false;
                setSkubyref(props.skubyrefrence);
                setSelectedBrandId(props.skubyrefrence.brand_id);
                if (props.skubyrefrence.brand_id) {
                    let brandname = props.brands.map(b => b).filter((brand) => {
                        if (brand.brand_id === props.skubyrefrence.brand_id) {
                            return brand;
                        }
                    });
                    if(brandname && brandname.length>0){
                        setSelectedBrand({ brand_id: brandname[0].brand_id, brand_name: brandname[0].brand_name });
                    }

                }
                ignoreStatus = (props.skubyrefrence.ignoreUpc?true:false);
                setIgnoreSKU(props.skubyrefrence.ignoreUpc?true:false);
                setIgnoreSKULPD(props.skubyrefrence.ignoreLUP);
                setSelectedPackageTypeId(props.skubyrefrence.package_type_id);
                setSelectedPackageType({ package_type_id: props.skubyrefrence.package_type_id, package_name: props.skubyrefrence.package_category_name });
                setWeight(props.skubyrefrence.weight);
                setLength(props.skubyrefrence.length);
                setHeight(props.skubyrefrence.height);
                setWidth(props.skubyrefrence.width);
                setSkuPackagesPerCase(props.skubyrefrence.sku_packages_per_case);

                setSKUVORRefNumber(props.skubyrefrence.vor_reference_number);
                setSKURefNumber(props.skubyrefrence.customer_reference_number);
                setSKUDescription(props.skubyrefrence.long_description);

                setDCWeight(props.skubyrefrence.dc_weight);
                setDCLength(props.skubyrefrence.dc_length);
                setDCHeight(props.skubyrefrence.dc_height);
                setDCWidth(props.skubyrefrence.dc_width);
                setDCSkuPackagesPerCase(props.skubyrefrence.dc_sku_packages_per_case);

                setUnitsPerCase(props.skubyrefrence.units_per_case);

                if (props.skubyrefrence.is_weight_verified_on_scale === false) {
                    setWeightVerified({ name: props.skubyrefrence.is_weight_verified_on_scale })
                    setSelectedWeightVerified(0);
                } else if (props.skubyrefrence.is_weight_verified_on_scale === true) {
                    setWeightVerified({ name: props.skubyrefrence.is_weight_verified_on_scale })
                    setSelectedWeightVerified(1);
                } else { setWeightVerified() }
                setReferenceNumber(props.skubyrefrence.vor_reference_number);
                setUpc(props.skubyrefrence.upc);
                upcNumber = props.skubyrefrence.upc;
                vorRefNumber = props.skubyrefrence.vor_reference_number;
                setFormUPC(props.skubyrefrence.upc);
                setCaseUPC(props.skubyrefrence.case_upc);
                setUnitUPC(props.skubyrefrence.unit_upc);
                if (props.skubyrefrence.date_weight_was_verified) {
                    let year = props.skubyrefrence.date_weight_was_verified.slice(0, 4);
                    let month = props.skubyrefrence.date_weight_was_verified.slice(5, 7);
                    let day = props.skubyrefrence.date_weight_was_verified.slice(8, 10);

                    let selectedDate = `${month}-${day}-${year}`;
                    setDateweightverifiedCopy(selectedDate);
                }

            }
        }catch (ex){
            console.log("Error:"+ex.message);
        }

    }, [props.skubyrefrence])

    useEffect(() => {
        if (!weightVerified) {
            setSelectedWeightVerified()
            setWeightVerified()
        }
        if (!dateweightverifiedCopy === "") {
            setDateweightverifiedCopy()
        }
        if (!dateWeightVerified) {
            setDateWeightVerified();
        }
        if (!length || length === "") {
            setLength();
        }
        if (!weight || weight === "") {
            setWeight();
        }
        if (!height || height === "") {
            setHeight();
        }
        if (!width || width === "") {
            setWidth();
        }
        if (!skuPackagesPerCase || skuPackagesPerCase === "") {
            setSkuPackagesPerCase();
        }


        if (!dcweight || dcweight === "") {
            setDCWeight();
        }
        if (!dcheight || dcheight === "") {
            setDCHeight();
        }
        if (!dcwidth || dcwidth === "") {
            setDCWidth();
        }
        if (!dclength || dclength === "") {
            setDCLength();
        }
        if (!dcskuPackagesPerCase || dcskuPackagesPerCase === "") {
            setDCSkuPackagesPerCase();
        }

        if (!unitsPerCase || unitsPerCase === "") {
            setUnitsPerCase();
        }

        if(!skuVORRefNumber){
            setSKUVORRefNumber("");
        }
        if(!skuCustRefNumber){
            setSKURefNumber("");
        }
        if(!skuDescription){
            setSKUDescription("");
        }

    }, [weightVerified, dateWeightVerified, length, weight, height, width])

    const handleBrandChange = (event) => {
        setSelectedBrand(event);
        setSelectedBrandId(event.brand_id);
    }
    const handlePackageTypeChange = (event) => {
        setSelectedPackageType(event);
        setSelectedPackageTypeId(event.package_type_id);
    }
    const handlesearchSKUChange = (event) => {
       // setIndicatorOn(true)
        searchClick = true;
        setSearchSKU(event.target.value);
        setListOpen(true);
    }
    const handleReferenceChange = (event) => {
        searchClick = false;
        vorRefNumber = event.target.value;
        setReferenceNumber(vorRefNumber);
    }
    const handleUpcChange = (event) => {
        searchClick = false;
        upcNumber = event.target.value;
        setUpc(upcNumber);
    }
    const handleFormUpcChange = (event) => {
        setFormUPC(event.target.value);
    }
    const handleCaseUPCChange = (event) => {
        setCaseUPC(event.target.value);
    }
    const handleUnitUPCChange = (event) => {
        setUnitUPC(event.target.value);
    }
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    }
    const handleDCWeightChange = (event) => {
        setDCWeight(event.target.value);
    }
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    }
    const handleDCHeightChange = (event) => {
        setDCHeight(event.target.value);
    }
    const handleLengthChange = (event) => {
        setLength(event.target.value);
    }
    const handleDCLengthChange = (event) => {
        setDCLength(event.target.value);
    }
    const handleWidthChange = (event) => {
        setWidth(event.target.value);
    }
    const handleDCWidthChange = (event) => {
        setDCWidth(event.target.value);
    }
    const handleSkuAttributeTypeChange = (event) => {
        checkOption = event.target.value;
        setSkuAttributeType(checkOption);
        setSkubyref('');
        setListOpen(false);
        setSearchSKU();
        setDisable(true);
        setDCDisable(true);
        isDCSubmitted = false;
        isCustomerSubmitted = false;
        ignoreStatus = false;
        setIgnoreSKU(ignoreStatus);
        setIgnoreSKULPD("");
        upcNumber = "";
        vorRefNumber = "";
        setError(null);
        setSuccess(null);
        setReferenceNumber("");
        setUpc("");
        //searchClick = false;
        props.clearError();
        //yield all([put(Actions.LOAD_SKUSBY_REFRENCE_WITH_ERROR(error))]);
        clearAllVal();
    };
    let clearFormData = ()=>{
        checkOption = LBL_SEARCH_SKU;
        setSkuAttributeType(checkOption);
        setSelectedCustomer("");
        setSelectedCustomerName("");
        setSkubyref('');
        setListOpen(false);
        setSearchSKU("");
        setDisable(true);
        setDisable(true);
        ignoreStatus = false;
        setIgnoreSKU(ignoreStatus);
        setIgnoreSKULPD("");
        upcNumber = "";
        vorRefNumber = "";
        setUpc("");
        setReferenceNumber("")

        clearAllVal();
    }
    const handleUnitsPerCaseChange = (event) => {
        setUnitsPerCase(event.target.value);
    };
    const handleSkuPackagesPerCaseChange = (event) => {
        setSkuPackagesPerCase(event.target.value);
    };
    const handleDCSkuPackagesPerCaseChange = (event) => {
        setDCSkuPackagesPerCase(event.target.value);
    };
    const clearAllVal = () => {
        setSelectedBrandId();
        setSelectedBrand()
        setSelectedPackageTypeId();
        setSelectedPackageType();
        setWeight();
        setLength();
        setHeight();
        setWidth();
        setDCWidth();
        setDCWeight();
        setDCLength();
        setDCHeight();
        setDCSkuPackagesPerCase();
        setUnitsPerCase();
        setSkuPackagesPerCase();
        setWeightVerified();
        setDateWeightVerified();
        //setReferenceNumber("");
        //setUpc("");
        setFormUPC("")
        setCaseUPC("")
        setUnitUPC("")
        setSKUVORRefNumber("");
        setSKURefNumber("");
        setSKUDescription("");

    }

    let clearFormFields = ()=>{
        setSelectedBrandId();
        setSelectedBrand()
        setSelectedPackageTypeId();
        setSelectedPackageType();
        setWeight();
        setLength();
        setHeight();
        setWidth();
        setDCWidth();
        setDCWeight();
        setDCLength();
        setDCHeight();
        setDCSkuPackagesPerCase();
        setUnitsPerCase();
        setSkuPackagesPerCase();
        setSKUVORRefNumber("");
        setSKURefNumber("");
        setSKUDescription("");
        setWeightVerified();
        setDateWeightVerified();
        setFormUPC()
        setCaseUPC()
        setUnitUPC()
        ignoreStatus = false;
        setIgnoreSKU(false);
    }

    useEffect(() => {
        if (dateWeightVerified) {
            setDateweightverifiedCopy()
        } else {
            setDateWeightVerified();
        }
    }, [dateWeightVerified])

    const defaultPropsBrand = {
        options: brands,
        getOptionLabel: (option) => option.brand_name,
    };
    const defaultPropsPackageType = {
        options: packageType,
        getOptionLabel: (option) => option.package_name,
    };
    const defaultweightVerifiedScale = {
        options: weightVerifiedValues,
        getOptionLabel: (option) => option.name,
    };

    const handleVorDCChange = (event)=>{
        console.log(event.target.value)
        dcName = event.target.value;
        dcId = event.target.value.dc_id;
        setSelectedDC(dcName)
        setSelectedDCId(dcId)

       // skuDescption = "";
       // skuDescriptionId = "";
        //customerReferenceId = "";
       // setSearchSKU("");
        //ignoreStatus = false;
        //setIgnoreSKU(false);
        //setIgnoreSKULPD("");
        searchClick = false;
        setSkubyref('');
        //setDisable(true);
        setDCDisable(true);
        isDCSubmitted = false;
        //setIndicatorOn(true)

        //clearAllVal();

        isSkuDescLoaded = false;
        submitButtonFlag = false;
        isSkuDescLoaded = false;
        //setSearchSKU("");
       // setSelectedrefrence("");
         setIndicatorOn(true)

        setTimeout(()=>{
            setIndicatorOn(false)
        },2000)

        setTimeout(()=>{
            setSearchSKU(skuDescption);
            setSelectedrefrence(skuDescriptionId);
           // SearchSkus();
            props.fetchSkuByRefrence(checkOption,referenceNumber, upc,selectedCustomerId,dcId);
        },100);
    }
    const handleVorCustomerChange = (event) => {
        customerName = event.target.value;
        customerId = event.target.value.customer_id;
        customerDCs = event.target.value.dcs;
        setCustomerDC(customerDCs);
        setSelectedCustomer(customerName);
        setSelectedCustomerId(customerId);
        dcName = "";
        dcId = ""
       // setIndicatorOn(true)
        setSelectedDC("");
        setSelectedDCId("")

        skuDescption = "";
        skuDescriptionId = "";
        customerReferenceId = "";
        //setSearchSKU("");
        ignoreStatus = false;
        setIgnoreSKU(false);
        setIgnoreSKULPD("");
        searchClick = false;
        setSkubyref('');
        setDisable(true);
        setDCDisable(true);
        isDCSubmitted = false;
        isCustomerSubmitted = false;

        clearAllVal();
        let jwt = localStorage.getItem('authToken');
        props.fetchBrands(jwt, event.target.value.customer_id);
        props.fetchPackageType(jwt, event.target.value.customer_id);
        props.fetchSkusByDesc(jwt, event.target.value.customer_id);
    }
    const handleWeightVerifiedChange = (event) => {
        setWeightVerified(event);
        if (event.name === 'false') {
            setSelectedWeightVerified(0);
        } else if (event.name === 'true') {
            setSelectedWeightVerified(1);
        } else {
            setSelectedWeightVerified();
        }
    }

    const handleSKUvalue = (event) => {
        //clearAllVal();
       // console.log(allskus);

        clearFormFields();
        submitButtonFlag = false;
        isSkuDescLoaded = false;
        skuDescption = event.currentTarget.textContent;
        skuDescriptionId = event.currentTarget.id;
        customerReferenceId = getCustomerReferenceNumber(skuDescriptionId)
        setListOpen(false);
        setSearchSKU("");
        setSelectedrefrence("");
        setIndicatorOn(true)

        setTimeout(()=>{
            setSearchSKU(skuDescption);
            setSelectedrefrence(skuDescriptionId);

        },1000);

    }

    let getCustomerReferenceNumber = (vorReferenceId) => {
        for (let i = 0; i < allskus.length; i++) {
            if(allskus[i].id === vorReferenceId) {
                return allskus[i].customer_id;
            }
        }
        return null;
    }

    const closeList = () => {
        setListOpen(false);
    }
    const SearchSkus = () => {
        setIndicatorOn(true)
       // console.log(checkOption);
        submitButtonFlag = false;
        clearFormFields();
        searchClick = false;
        props.fetchSkuByRefrence(checkOption,referenceNumber, upc,selectedCustomerId,dcId);
    }

    useEffect(() => {
       // console.log("update weight status"+props.updateweightstatus)
        if (props.updateweightstatus) {
            setSuccess(props.updateweightstatus);
        }
        if (props.error) {
            //searchClick = false;
            setError(props.error)
        }
        if (error !== null) {
            setIndicatorOn(false)
            callReUpdate();
        }
        if(submitButtonFlag){
            submitButtonFlag = false;
            console.log(checkOption)
            if (success === 'Successfully updated vor_sku table') {
                if(checkOption == LBL_SEARCH_SKU){
                    setSelectedrefrence(skuDescriptionId)
                }

                setIndicatorOn(false);
                callReUpdate();
            }
        }

    }, [props.error, props.updateweightstatus, error, success])

    const callReUpdate = () => {
        setTimeout(() => {
            setError(null);
            setSuccess(null);
        }, 1500);
    }

    const editDetails = () => {
        try{
            if (disable) {
                setDisable(false);
            } else {
                submitButtonFlag = true;
                dataLoading = true;
                searchClick = true;
                isSkuDescLoaded = false;
                console.log(selectedCustomer,selectedCustomerId);
                isCustomerSubmitted = true;
                setrand(Math.random()*100000)
                let selectedDate = dateWeightVerified ? dateWeightVerified.format("MM-DD-YYYY") : undefined;
                if(weight && height && length && width && unitsPerCase && skuPackagesPerCase){
                setIndicatorOn(true);
                    props.updateWeight("update", formUPC, referenceNumber, weight, height, length, width, selectedPackageTypeId, unitsPerCase, selectedBrandId, skuPackagesPerCase, selectedWeightVerified, dateweightverifiedCopy, selectedDate,selectedCustomerId,ignoreSKU,"",caseUPC,unitUPC);
                    isCustomerSubmitted = false;
                }

            }
        }catch (ex){
            console.log("Error:"+ex.message);
        }
    }
    const editDCDetails = () => {
        try{
            if (dcdisable) {
                setDCDisable(false);
            } else {
                submitButtonFlag = true;
                dataLoading = true;
                searchClick = true;
                isSkuDescLoaded = false;
                console.log(selectedCustomer,selectedCustomerId);

                isDCSubmitted = true;
                setrand(Math.random()*10000000)
                let selectedDate = dateWeightVerified ? dateWeightVerified.format("MM-DD-YYYY") : undefined;
                if(dcId && dcweight && dcheight && dclength && dcwidth && dcskuPackagesPerCase){
                    setIndicatorOn(true);
                    props.updateWeight("update", formUPC, referenceNumber, dcweight, dcheight, dclength, dcwidth, selectedPackageTypeId, unitsPerCase, selectedBrandId, dcskuPackagesPerCase, selectedWeightVerified, dateweightverifiedCopy, selectedDate,selectedCustomerId,ignoreSKU,dcId,caseUPC,unitUPC);
                    isDCSubmitted = false;
                }

            }
        }catch (ex){
            console.log("Error:"+ex.message);
        }
    }

    const handleTextDateWeightverified = () => {
        setDateweightverifiedCopy();
    }

    return (
        <div style={{ width: '100%' }}>
            {indicatorOn ?
                <div>
                    <Backdrop
                         sx={{ color: '#000', backgroundColor: 'rgb(255,255,255,0.7)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={indicatorOn}
                    >
                        <p>Please wait, while data is loading...</p> <CircularProgress color="inherit" />
                    </Backdrop>
                </div> : ''
            }
            <div>
                {customersVorList && <FormControl sx={{ width: '300px', boxShadow: 'none', marginTop: '30px', marginRight: '20px' }}>
                    <InputLabel id="demo-multiple-name-label">Customers</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        label="Customers"
                        value={selectedCustomer || 'Select All'}
                        onChange={handleVorCustomerChange}
                        sx={{ textAlign: 'left' }}>
                        <MenuItem key={0} value={'Select All'}>
                            Select All
                        </MenuItem>
                        {customersVorList.map((item) => (
                            <MenuItem key={item.customer_id} value={item}>
                                {item.customer_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>}

            </div>
            <FormControl sx={{ marginTop: '20px' }}>
                <FormLabel id="demo-row-radio-buttons-group-label">Choose 1 type</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={skuAttributeType}
                    onChange={handleSkuAttributeTypeChange}
                >
                    <FormControlLabel value="Search SKU" control={<Radio />} label="Search with the SKU Description" />
                    <FormControlLabel value="reference" control={<Radio />} label="VOR Reference Number" />
                    <FormControlLabel value="upc" control={<Radio />} label="Package UPC" />
                </RadioGroup>
            </FormControl>
            <Box
                sx={{
                    '& .MuiTextField-root': { width: '300px', boxShadow: 'none', marginTop: '20px', marginRight: '20px' },
                }}
                noValidate
            >

            </Box>
            {
                customersVorList &&
                <Box
                    sx={{
                        '& .MuiTextField-root': { width: '300px', boxShadow: 'none', marginTop: '20px', marginRight: '20px' },
                    }}
                    noValidate
                >
                    {skuAttributeType === 'Search SKU' && <TextField
                        id="outlined-name"
                        label="Search with the SKU Description"
                        value={searchSKU}
                        onChange={handlesearchSKUChange}
                        error={error1}
                        autoComplete={"off"}
                        helperText={error1 && "Hint: Enter your text here"}
                        style={{ backgroundColor: '#fff' }}
                    />}
                    {skuAttributeType === 'reference' && <TextField
                        id="outlined-name"
                        label="VOR Reference Number*"
                        value={referenceNumber ? referenceNumber : ''}
                        onChange={handleReferenceChange}
                        error={error1}
                        autoComplete={"off"}
                        helperText={error1 && "Hint: Enter your text here"}
                        style={{ backgroundColor: '#fff' }}
                    />}
                    {skuAttributeType === 'upc' && <TextField
                        id="outlined-name"
                        label="Package UPC*"
                        value={upc || ''}
                        onChange={handleUpcChange}
                        error={error1}
                        autoComplete={"off"}
                        helperText={error1 && "Hint: Enter your text here"}
                        style={{ backgroundColor: '#fff' }}
                    />}
                    {(listOpen && skuAttributeType === 'Search SKU') ?
                        <>
                            <IconButton aria-label="cancel" color="default"
                                sx={{ position: 'absolute', margin: '65px 0px 0px -30px' }}
                                onClick={closeList}
                            >
                                <CancelPresentationIcon />
                            </IconButton>
                            <List
                                sx={{
                                    position: 'absolute', zIndex: '1030', background: '#fff',
                                    width: '300px', height: '350px', overflowY: 'scroll', border: '1px solid #ccc'
                                }}>

                                {allskus &&
                                    allskus
                                        .filter(item => item.long_description.toLowerCase().includes(searchSKU.toLowerCase()))
                                        .map((skuItem, i) => {
                                            return <ListItem key={i}
                                                id={skuItem.vor_reference_number} itemID={123}
                                                sx={{ fontSize: '13px', cursor: 'pointer' }}
                                                onClick={handleSKUvalue}

                                            >{skuItem.long_description}
                                            </ListItem>
                                        })
                                }
                            </List>
                        </> : ''}
                    {((referenceNumber && skuAttributeType === 'reference') || (upc && skuAttributeType === 'upc')) ?
                        <Button variant="contained"
                            sx={{ marginTop: '30px' }}
                            onClick={SearchSkus}
                        >
                            Search Sku
                        </Button> : ''
                    }
                </Box>
            }

            <div style={{ paddingTop: '40px', width: '100%', display: 'flex' }}>
                <div style={{width:'60%'}}>
                    <fieldset style={{border:"0.1px solid"}}>
                        <legend style={{fontWeight:"bold"}}>Master Attributes</legend>
                        <div style={{padding:'10px',display:'flex',flexDirection:'column',gap:'20px'}}>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                {brands && <Autocomplete
                    {...defaultPropsBrand}
                    //getOptionSelected={(option, value) => option.id === value.id}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    value={selectedBrand || null}
                    disabled={(upc || disable)  ? disable : enable}
                    onChange={(e, v) => handleBrandChange(v)}
                                        sx={{ float: 'left', width: "100%", marginRight: '20px' }}
                    renderInput={(params) => (
                        <TextField {...params} label="Brand" variant="standard" />
                    )}
                />}
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}>
                                </Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                {packageType && <Autocomplete
                    {...defaultPropsPackageType}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    disabled={(upc || disable) ? disable : enable}
                    value={selectedPackageType || null}
                    onChange={(e, v) => handlePackageTypeChange(v)}
                                        sx={{ float: 'left', width: "100%", marginRight: '20px' }}
                    renderInput={(params) => (
                        <TextField {...params} label="Package Type" variant="standard" />
                    )}
                />}
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                    label="Weight"
                                        sx={{width:'100%'}}
                    value={weight || ''}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={handleWeightChange}
                                        error={!isCustomerSubmitted?false:(weight?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                    style={{ backgroundColor: '#fff' }}
                />
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                    label="Length"
                    value={length || ''}
                                        sx={{width:'100%'}}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={handleLengthChange}
                                        error={!isCustomerSubmitted?false:(length?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                    label="Width"
                                        sx={{width:'100%'}}
                    value={width || ''}
                    onChange={handleWidthChange}
                    disabled={(upc || disable) ? disable : enable}
                                        error={!isCustomerSubmitted?false:(width?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                />
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                    label="Height"
                                        sx={{width:'100%'}}
                    value={height || ''}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={handleHeightChange}
                                        error={!isCustomerSubmitted?false:(height?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                                        sx={{width:'100%'}}
                    label="Units Per Case"
                    value={unitsPerCase ? unitsPerCase : ''}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={handleUnitsPerCaseChange}
                                        error={!isCustomerSubmitted?false:(unitsPerCase?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                />
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                <TextField
                    id="outlined-name"
                                        sx={{width:'100%'}}
                    label="SKU Packages Per Case"
                    value={skuPackagesPerCase ? skuPackagesPerCase : ''}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={handleSkuPackagesPerCaseChange}
                                        error={!isCustomerSubmitted?false:(skuPackagesPerCase?false:true)}
                    helperText={error1 && "Hint: Enter your text here"}
                    style={{ backgroundColor: '#fff' }}
                />
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                {weightVerifiedValues && <Autocomplete
                    {...defaultweightVerifiedScale}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    value={weightVerified ? weightVerified : null}
                    disabled={(upc || disable) ? disable : enable}
                    onChange={(e, v) => handleWeightVerifiedChange(v)}
                                        sx={{ float: 'left', width: "100%", marginRight: '20px' }}
                    renderInput={(params) => (
                        <TextField {...params} label="Weight verified on scale" variant="standard" />
                    )}
                />}
                                </Grid>

                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                {dateweightverifiedCopy ?
                    <TextField
                        id="outlined-name"
                        label="Date weight verified"
                                            sx={{width:'100%'}}
                        value={dateweightverifiedCopy || ''}
                        disabled={(upc || disable) ? disable : enable}
                        onClick={handleTextDateWeightverified}
                        helperText={"Hint: MM-DD-YYYY"}
                        style={{ backgroundColor: '#fff' }}
                    /> : ''}
                {!dateweightverifiedCopy ?
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker label="Date weight verified"
                                                            sx={{width:'100%'}}
                                value={dateWeightVerified}
                                disabled={(upc || disable) ? disable : enable}
                                onChange={(newValue) => setDateWeightVerified(newValue)}
                                format="MM-DD-YYYY"
                            />
                        </DemoContainer>
                    </LocalizationProvider> : ''
                }
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                    <TextField
                                        id="outlined-name"
                                        sx={{width:'100%'}}
                                        label="Vor Reference Number"
                                        value={skuVORRefNumber ? skuVORRefNumber : ''}
                                        disabled={true}
                                        helperText={error1 && "Hint: Enter your text here"}
                                    />
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                    <TextField
                                        id="outlined-name"
                                        label="SKU Description"
                                        sx={{width:'100%'}}
                                        value={skuDescription || ''}
                                        disabled={true}

                                        helperText={error1 && "Hint: Enter your text here"}
                                        style={{ backgroundColor: '#fff' }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                    <TextField
                                        id="case-upc"
                                        label="Case UPC"
                                        sx={{width:'100%'}}
                                        value={caseUPC || ''}
                                        disabled={(upc || disable) ? disable : enable}
                                        onChange={handleCaseUPCChange}
                                        style={{ backgroundColor: '#fff' }}
                                    />
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                    <TextField
                                        id="unit-upc"
                                        label="Unit UPC"
                                        sx={{width:'100%'}}
                                        value={unitUPC || ''}
                                        disabled={(upc || disable) ? disable : enable}
                                        onChange={handleUnitUPCChange}
                                        style={{ backgroundColor: '#fff' }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                {(skuAttributeType === 'reference' || skuAttributeType === 'Search SKU' || skuAttributeType === 'upc') ? <TextField
                                    id="outlined-name"
                                    label="Package UPC"
                                    sx={{width:'100%'}}
                                    value={formUPC || ''}
                                    disabled={(upc || disable) ? disable : enable}
                                    onChange={handleFormUpcChange}
                                    error={error1}
                                    helperText={error1 && "Hint: Enter your text here"}
                                    style={{ backgroundColor: '#fff' }}
                                /> : ''}
                                </Grid>
                                <Grid xs={1} lg={1} xl={1}></Grid>
                                <Grid xs={5.5} lg={5.5} xl={5.5}>
                                    <div style={{display:(selectedCustomerId?"inline-table":"none"),paddingTop:"5px"}}>
                                        <FormControlLabel control={<Checkbox checked={ignoreSKU} onChange={(event)=>{
                                            console.log(event.target.checked);
                                            ignoreStatus = event.target.checked;
                                            setIgnoreSKU(event.target.checked);
                                        }}   />}  disabled={(upc || disable) ? disable : enable} label="Ignore SKU"  /> <br/>
                                        <label style={{color:'#a29b9b',fontSize:"13px"}}>Note: Ignore selection last updated {moment(ignoreSKULUD?ignoreSKULUD:new Date()).format("MM/DD/YYYY")}</label>
                                    </div>
                                </Grid>
                            </Grid>



                    <Box sx={{ display: 'flex',textAlign:'center',justifyContent:'center' }}>
                        <div>
                            {(user.canWrite) ?
                                <div style={{ paddingTop: '20px' }}>
                                    <Button variant="contained"
                                            onClick={editDetails}
                                            disabled={false}
                                            sx={{ width: '200px' }}>{disable ? 'Edit' : 'Submit'}</Button>
                                </div> : ''}

                        </div>
            </Box>
                        </div>
                    </fieldset>
                </div>
                <div style={{width:'50%'}}>
                    <fieldset style={{border:"0.1px solid"}}>
                        <legend style={{fontWeight:"bold"}}>DC Attributes</legend>
                        <div>


                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { width: '300px', boxShadow: 'none', marginTop: '5px', marginRight: '20px' },
                        }}
                        noValidate>
                        <TextField
                            id="outlined-name"

                            label="Customer Reference Number"
                            value={skuCustRefNumber ? skuCustRefNumber : ''}
                            disabled={true}
                            helperText={error1 && "Hint: Enter your text here"}
                            style={{ backgroundColor: '#fff' }}
                        />
                        <div>
                        {customersVorList && <FormControl sx={{ width: '300px', boxShadow: 'none', marginTop: '10px', marginRight: '20px' }}>
                            <InputLabel id="demo-multiple-name-label">Distribution Center</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                label="Distribution Center"
                                value={selectedDC}
                                onChange={handleVorDCChange}
                                error={!isDCSubmitted?false:(selectedDC?false:true)}
                                sx={{ textAlign: 'left' }}>

                                {customerDC && customerDC.map((item) => (
                                    <MenuItem key={item.dc_id} value={item}>
                                        {item.dc_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        }
                        </div>
                        <div style={{marginTop: '10px'}}>
                        <TextField
                            id="outlined-name"
                            label="Weight"
                            value={dcweight || ''}
                            disabled={(upc || dcdisable) ? dcdisable : enable}
                            onChange={handleDCWeightChange}

                            error={!isDCSubmitted?false:(dcweight?false:true)}
                            helperText={error1 && "Hint: Enter your text here"}
                            style={{ backgroundColor: '#fff' }}
                        />
                        </div>
                        <div style={{marginTop: '10px'}}>
                        <TextField
                            id="outlined-name"
                            label="Length"
                            value={dclength || ''}
                            disabled={(upc || dcdisable) ? dcdisable : enable}
                            onChange={handleDCLengthChange}
                            error={!isDCSubmitted?false:(dclength?false:true)}
                            helperText={error1 && "Hint: Enter your text here"}
                        />
                        </div>
                        <div style={{marginTop: '10px'}}>
                        <TextField
                            id="outlined-name"
                            label="Width"
                            value={dcwidth || ''}
                            onChange={handleDCWidthChange}
                            disabled={(upc || dcdisable) ? dcdisable : enable}
                            error={!isDCSubmitted?false:(dcwidth?false:true)}
                            helperText={error1 && "Hint: Enter your text here"}
                        />
                        </div>
                        <div style={{marginTop: '10px'}}>
                        <TextField
                            id="outlined-name"
                            label="Height"
                            value={dcheight || ''}
                            disabled={(upc || dcdisable) ? dcdisable : enable}
                            onChange={handleDCHeightChange}
                            error={!isDCSubmitted?false:(dcheight?false:true)}
                            helperText={error1 && "Hint: Enter your text here"}
                        />
                        </div>
                        <div style={{marginTop: '10px'}}>
                        <TextField
                            id="outlined-name"
                            label="SKU Packages Per Case"
                            value={dcskuPackagesPerCase ? dcskuPackagesPerCase : ''}
                            disabled={(upc || dcdisable) ? dcdisable : enable}
                            onChange={handleDCSkuPackagesPerCaseChange}
                            error={!isDCSubmitted?false:((dcskuPackagesPerCase)?false:true)}
                            helperText={error1 && "Hint: Enter your text here"}
                            style={{ backgroundColor: '#fff' }}
                        />
                        </div>
            <Box sx={{ display: 'flex' }}>
                            <div style={{ paddingTop: '20px' }}>
                                {(user.canWrite) ?
                    <div style={{ paddingTop: '30px' }}>
                        <Button variant="contained"
                                                onClick={editDCDetails}
                            disabled={false}
                                                sx={{ width: '200px' }}>{dcdisable ? 'Edit' : 'Submit'}</Button>
                    </div> : ''}

                            </div>
                        </Box>
            </Box>
        </div>
                        </fieldset>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        brands: state.skuUpdate.brands,
        packageType: state.skuUpdate.packageType,
        skusbydesc: state.skuUpdate.skusbydesc,
        skubyrefrence: state.skuUpdate.skubyrefrence,
        error: state.skuUpdate.error,
        updateweightstatus: state.skuUpdate.updateweightstatus,
        user: state.application.user

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        clearError:()=>dispatch(Actions.LOAD_SKUSBY_REFRENCE_WITH_ERROR("")),
        updateWeight: (action, upc, reference, weight, height, length, width, packageTypeId, unitsPerCase, brandId, skuPackagesPerCase, isWeightVerified, dateweightverifiedCopy, selectedDate,customerId,ignoreSKU,dcId,caseUPC,unitUPC) => dispatch(Actions.UPDATE_WEIGHT(action, upc, reference, weight, height, length, width, packageTypeId, unitsPerCase, brandId, skuPackagesPerCase, isWeightVerified, dateweightverifiedCopy, selectedDate,customerId,ignoreSKU,dcId,caseUPC,unitUPC)),
        fetchBrands: (authToken, customerId) => dispatch(Actions.LOAD_BRANDS(authToken, customerId)),
        fetchPackageType: (authToken, customerId) => dispatch(Actions.LOAD_PACKAGE_TYPE(authToken, customerId)),
        fetchSkusByDesc: (authToken, customerId) => dispatch(Actions.LOAD_SKUSBY_DESC(authToken, customerId)),
        fetchSkuByRefrence: (searchOption,referenceNumber, upc,customerId,dcId) => dispatch(Actions.LOAD_SKUSBY_REFRENCE(searchOption,referenceNumber, upc,customerId,dcId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SkuUpdateTabAttribute);
